/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { ITeamResponse } from './ITeamResponse';
import {
    ITeamResponseFromJSON,
    ITeamResponseFromJSONTyped,
    ITeamResponseToJSON,
    ITeamResponseToJSONTyped,
} from './ITeamResponse';

/**
 * 
 * @export
 * @interface GetMyTeamsResponse
 */
export interface GetMyTeamsResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetMyTeamsResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<ITeamResponse>}
     * @memberof GetMyTeamsResponse
     */
    teams: Array<ITeamResponse>;
}

/**
 * Check if a given object implements the GetMyTeamsResponse interface.
 */
export function instanceOfGetMyTeamsResponse(value: object): value is GetMyTeamsResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('teams' in value) || value['teams'] === undefined) return false;
    return true;
}

export function GetMyTeamsResponseFromJSON(json: any): GetMyTeamsResponse {
    return GetMyTeamsResponseFromJSONTyped(json, false);
}

export function GetMyTeamsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMyTeamsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'teams': ((json['teams'] as Array<any>).map(ITeamResponseFromJSON)),
    };
}

export function GetMyTeamsResponseToJSON(json: any): GetMyTeamsResponse {
    return GetMyTeamsResponseToJSONTyped(json, false);
}

export function GetMyTeamsResponseToJSONTyped(value?: GetMyTeamsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'teams': ((value['teams'] as Array<any>).map(ITeamResponseToJSON)),
    };
}

